export enum FlagStatusLabel {
  Positive = 'Positive',
  Negative = 'Negative',
  InProgress = 'In progress',
  OnHold = 'On hold',
}
